export * from './post-extra-vereinbarung.component';
export * from './post-extra-vereinbarung.component.module';